import { TStudent } from "types/JsonType";

export const Students = [
  {
    firstName: "Corban",
    lastName: "Procuniar",
    imgSrc: require("lib/img/team/c_procuniar.jpg"),
    major: "Masters in Information Systems Management",
    role: "Web Developer",
    started: new Date("2023/10/28"),
    ended: null,
    linkedin: "https://www.linkedin.com/in/corbanprocuniar",
  },
  {
    firstName: "Tyler",
    lastName: "Hill",
    imgSrc: require("lib/img/team/t_hill.jpg"),
    major: "Strategic Management",
    role: "Research Assistant",
    started: new Date("2024/01/01"),
    ended: new Date("2024/12/01"),
    linkedin: "https://www.linkedin.com/in/tylerhillconnect/",
  },
  {
    firstName: "Jonah",
    lastName: "Heninger",
    imgSrc: require("lib/img/team/j_heninger.jpg"),
    major: "Strategic Management",
    role: "Research Assistant",
    started: new Date("2024/04/01"),
    ended: null,
    linkedin: "https://www.linkedin.com/in/jonah-heninger-b22977292",
  },
  {
    firstName: "Davis",
    lastName: "Rush",
    imgSrc: require("lib/img/team/d_rush.jpg"),
    major: "Strategic Management",
    role: "Research Assistant",
    started: new Date("2024/04/01"),
    ended: null,
    linkedin: "https://www.linkedin.com/in/davis-rush-1654a8294",
  },
  {
    firstName: "Andrés",
    lastName: "Rich",
    imgSrc: require("lib/img/team/a_rich.jpg"),
    major: "Advertising Content Creating",
    role: "Media Specialist",
    started: new Date("2024/02/01"),
    ended: null,
    linkedin: "https://www.linkedin.com/in/andr%C3%A9s-rich/",
  },
  {
    firstName: "Calvin",
    lastName: "Scott",
    imgSrc: require("lib/img/team/c_scott.jpg"),
    major: "Advertising",
    role: "Media Manager/Creator",
    started: new Date("2024/02/01"),
    ended: null,
    linkedin: "https://www.linkedin.com/in/calvin-scott-5925722a4/",
  },
  {
    firstName: "Mason",
    lastName: "Briggs",
    imgSrc: require("lib/img/team/m_briggs.jpg"),
    major: "Strategic Management",
    role: "Research Assistant",
    started: new Date("2025/02/05"),
    ended: null,
    linkedin: "www.linkedin.com/in/mason-briggs-9971652b7",
  },
  {
    firstName: "Preston",
    lastName: "Pond",
    imgSrc: require("lib/img/team/p_pond.jpg"),
    major: "Strategic Management",
    role: "Research Assistant",
    started: new Date("2024/01/01"),
    ended: new Date("2024/12/01"),
    linkedin: "https://www.linkedin.com/in/prestonpond/",
  },
  /*

  {
    firstName: "",
    lastName: "",
    imgSrc: require("lib/img/team/c_scott.jpg"),
    major: "",
    role: "",
    started: new Date(""),
    ended: null,
    linkedin: "",
  },


   */
] as const satisfies TStudent[];

export default Students as TStudent[];
